import { render, staticRenderFns } from "./FormFiles.vue?vue&type=template&id=f7d8f468&"
import script from "./FormFiles.vue?vue&type=script&lang=ts&"
export * from "./FormFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports